<div class="card-header bg-success">
    <div class="row">
        <div class="col-md-6">
            <h3>Breakdown Report</h3>
        </div>
    </div>
</div>
<div class="card-body">
    <form #f="ngForm" (ngSubmit)="onSubmit(f)">
        <div class="row">
            <div class="col-md-6">
                <div class="alert alert-info" role="alert">
                    <small><strong>Note:</strong> Date selection is based on the <strong>transacted date</strong> of
                        customer records.</small>
                </div>
                <div class="form-group row">
                    <div class="col-md-4">Start Date</div>
                    <div class="col-md-8">
                        <input type="text" required name="bdr_start_date" placeholder="Start Date"
                            class="form-control form-control-sm datepicker" matInput (focus)="myDatepicker.open()"
                            [matDatepicker]="myDatepicker" [(ngModel)]="start_date" #bdr_start_date="ngModel"
                            [ngClass]="{ 'is-invalid': f.submitted && bdr_start_date.invalid }">
                        <mat-datepicker-toggle [for]="myDatepicker"></mat-datepicker-toggle>
                        <mat-datepicker #myDatepicker></mat-datepicker>
                        <div *ngIf="f.submitted && bdr_start_date.invalid" class="invalid-feedback">
                            Start date is required.
                        </div>
                    </div>
                </div>

                <div class="form-group row">
                    <div class="col-md-4">End Date</div>
                    <div class="col-md-8">
                        <input type="text" required name="bdr_end_date" placeholder="End Date"
                            class="form-control form-control-sm datepicker" matInput (focus)="endDateDatepicker.open()"
                            [matDatepicker]="endDateDatepicker" [(ngModel)]="end_date" #bdr_end_date="ngModel"
                            [ngClass]="{ 'is-invalid': f.submitted && bdr_end_date.invalid }">
                        <mat-datepicker-toggle [for]="endDateDatepicker"></mat-datepicker-toggle>
                        <mat-datepicker #endDateDatepicker></mat-datepicker>
                        <div *ngIf="f.submitted && bdr_end_date.invalid" class="invalid-feedback">
                            End date is required.
                        </div>
                    </div>
                </div>


                <div class="form-group">
                    <button class="btn btn-success btn-gray">Submit</button>
                </div>
            </div>
        </div>
    </form>
</div>